export default __webpack_public_path__ + "static/media/BarGraph.a8c812a1.svg";